import { UtilidadDashboard } from '../utilities/utilidad-dashboard';
import { MenuEstadistica } from './menu-estadistica';
import * as Highcharts from 'highcharts';

export class TablaCatalogoDatos {
    private utilidadDashboard: UtilidadDashboard = new UtilidadDashboard();
    public Highcharts: typeof Highcharts = Highcharts;

    id:number=0;
    idChart:string='';
    imagen!:string;
    titulo!:string;
    descripcion:string = '';
    tieneChart:boolean = false;
    highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options = this.utilidadDashboard.initChartGenerico(1, 'area');
    enlaces:Array<MenuEstadistica> = new Array;
}